import axios from '@/api/axios'

const createCalendarPlan = (plan) => {
  return axios.post('/calendarPlans', plan)
}

const getCalendarPlans = () => {
  return axios.get('/calendarPlans')
}

const getCalendarPlansKindsSport = (id, params) => {
  return axios.get(`/calendarPlans/${id}/filterResult`, {params})
}

const getCalendarPlansByParams = (params) => {
  return axios.get(`/calendarPlans${params}`).then((response) => response.data)
}

const getCalendarPlan = (id) => {
  return axios.get(`/calendarPlans/${id}/filter`)
}

const updateCalendarPlan = (id, planInput) => {
  return axios.put(`/calendarPlans/${id}`, planInput)
}

const deleteCalendarPlan = (id) => {
  return axios.delete(`/calendarPlans/${id}`)
}

export default {
  createCalendarPlan,
  getCalendarPlans,
  getCalendarPlansByParams,
  getCalendarPlan,
  updateCalendarPlan,
  deleteCalendarPlan,
  getCalendarPlansKindsSport,
}
